import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const routeLabels = {
  '/get-help': 'Get Help',
  '/help': 'I Want to Help',
  '/report-camp': 'Report Camp',
  '/donate': 'Donate',
  '/privacy': 'Privacy Policy',
  '/login': 'Admin Login',
  '/admin': 'Admin Dashboard',
};

const Breadcrumbs = ({ customCrumbs }) => {
  const location = useLocation();

  if (location.pathname === '/') {
    return null;
  }

  const defaultLabel = routeLabels[location.pathname] || 'Page';

  const crumbs = customCrumbs || [
    { name: 'Home', path: '/' },
    { name: defaultLabel, path: location.pathname, isCurrent: true },
  ];

  const jsonLdData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: `https://notbychanceoutreach.com${crumb.path}`,
    })),
  };

  return (
    <nav
      aria-label="Breadcrumb"
      className="max-w-6xl mx-auto w-full px-4 md:px-8 pt-4 pb-2 relative z-20"
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdData) }}
      />
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-slate-400 font-medium">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1 || crumb.isCurrent;
          return (
            <li key={crumb.path || index} className="flex items-center gap-1.5">
              {index > 0 && <span className="text-slate-600 font-normal">/</span>}
              {isLast ? (
                <span
                  className="text-banana-yellow font-bold uppercase tracking-wider"
                  aria-current="page"
                >
                  {crumb.name}
                </span>
              ) : (
                <Link
                  to={crumb.path}
                  className="hover:text-white uppercase tracking-wider transition-colors"
                >
                  {crumb.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
